/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MathFunctionIcon16Light } from './MathFunctionIcon16Light';
import { MathFunctionIcon16Regular } from './MathFunctionIcon16Regular';
import { MathFunctionIcon16Solid } from './MathFunctionIcon16Solid';
import { MathFunctionIcon20Light } from './MathFunctionIcon20Light';
import { MathFunctionIcon20Regular } from './MathFunctionIcon20Regular';
import { MathFunctionIcon20Solid } from './MathFunctionIcon20Solid';
import { MathFunctionIcon24Regular } from './MathFunctionIcon24Regular';
import { MathFunctionIcon24Solid } from './MathFunctionIcon24Solid';
import { MathFunctionIcon32Regular } from './MathFunctionIcon32Regular';
import { MathFunctionIcon64Regular } from './MathFunctionIcon64Regular';
var sizes = {
    16: {
        light: MathFunctionIcon16Light,
        regular: MathFunctionIcon16Regular,
        solid: MathFunctionIcon16Solid,
    },
    20: {
        light: MathFunctionIcon20Light,
        regular: MathFunctionIcon20Regular,
        solid: MathFunctionIcon20Solid,
    },
    24: {
        regular: MathFunctionIcon24Regular,
        solid: MathFunctionIcon24Solid,
    },
    32: {
        regular: MathFunctionIcon32Regular,
    },
    64: {
        regular: MathFunctionIcon64Regular,
    },
};
export var MathFunctionIcon = forwardRef('MathFunctionIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
